import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { getLocalUser } from '../../utils/localUser';
import config from '../../config';

import {
  SUGGEST_NAME_REQUEST,
  suggestNameSuccess,
  suggestNameFailure
} from '../actions/utilities';

function* suggestNameSaga(action) {
  try {
    const { prefix, postfix } = action.payload;
    
    // Build query parameters
    const params = new URLSearchParams();
    if (prefix) params.append('prefix', prefix);
    if (postfix) params.append('postfix', postfix);
    
    const queryString = params.toString();
    const url = `${config.API_URL}/utilities/suggest-name${queryString ? '?' + queryString : ''}`;
    
    const response = yield call(axios.get, url, {
      headers: getLocalUser()
    });
    
    if (response.data && response.data.data && response.data.data.name) {
      yield put(suggestNameSuccess(response.data.data.name));
    } else if (response.data && response.data.name) {
      yield put(suggestNameSuccess(response.data.name));
    } else {
      throw new Error('Invalid response format');
    }
  } catch (error) {
    console.error('Suggest name error:', error);
    yield put(suggestNameFailure(error.message || 'Failed to generate name suggestion'));
  }
}

export function* watchUtilities() {
  yield takeLatest(SUGGEST_NAME_REQUEST, suggestNameSaga);
}
